module.exports = __webpack_public_path__ + "img/tra_bg_rom@2x.cdfddd00.png";